
import { globalStyles } from '../../assets/globalStyles';
import React, { ReactElement } from 'react';
import { Error, Cancel, CheckCircle, Info } from '@material-ui/icons';
import {
    Box,
    Grid,
    Typography,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@material-ui/core';

export default function LegendeStoerung(
    props: { name: string }
): ReactElement {

    const classes = {
        ...globalStyles(),
    };

    const name = props.name;

    const [openLegendeDialog, setOpenLegendeDialog] = React.useState(false);

    return (
        <div>
            <Grid item md={12} style={{ textAlignLast: "right", marginTop: "-24px", marginBottom: "5px" }}>
                <Button
                    component={"div"}
                    onClick={() => {
                        openLegendeDialog ? setOpenLegendeDialog(false) : setOpenLegendeDialog(true)
                    }}
                    style={{ minWidth: "unset", marginLeft: "20px", color: "rgb(177, 177, 177)" }}
                >Legende
                    <Info style={{ marginLeft: "10px" }} />
                </Button>
                <Dialog open={openLegendeDialog} onClose={() => setOpenLegendeDialog(false)}>
                    <DialogTitle>Legende</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {name == "pqEreignis" || name == "gruppen" ? "" :
                                <Box display="flex" flexDirection="row" p={1} m={1}>
                                    <Box p={1}><Cancel className={classes.redSignalColor} /></Box>
                                    <Box p={1}><Typography>Störung</Typography></Box>
                                </Box>
                            }
                            {name == "betriebsereignis" ? "" :
                                <Box display="flex" flexDirection="row" p={1} m={1}>
                                    <Box p={1}><Error className={classes.redSignalColor} /></Box>
                                    <Box p={1}><Typography>Abschnittsereignis (länger 1 Sekunde)</Typography></Box>
                                </Box>
                            }
                            {name == "betriebsereignis" ? "" :
                                <Box display="flex" flexDirection="row" p={1} m={1}>
                                    <Box p={1}><Error style={{ color: "orange" }} /></Box>
                                    <Box p={1}><Typography>Punktereignis (kürzer 1 Sekunde)</Typography></Box>
                                </Box>
                            }
                            <Box display="flex" flexDirection="row" p={1} m={1}>
                                <Box p={1}><Error style={{ color: "green" }} /></Box>
                                <Box p={1}><Typography>Störung bei geplanten Ereignissen</Typography></Box>
                            </Box>
                            <Box display="flex" flexDirection="row" p={1} m={1}>
                                <Box p={1}><CheckCircle style={{ color: "green" }} /></Box>
                                <Box p={1}><Typography >Keine Störung</Typography></Box>
                            </Box>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            color="secondary"
                            variant="contained"
                            onClick={() => setOpenLegendeDialog(false)}
                            className={classes.cancleDeleteButton}
                        >
                            Schliessen
                        </Button>
                    </DialogActions>
                </Dialog>
            </Grid>
        </div>
    )
}
